export default __webpack_public_path__ + "449aa8c65cdc5c2a868645403b9ea4d3.woff";